// extracted by mini-css-extract-plugin
export default {"table-title":"TableHeading_table-title__y3+sX","table-type":"TableHeading_table-type__Wi2wn"};